<template>
  <div class="interview">
    <div class="top pos-top">
      <new-head title="简历筛选" :isBack="false"> </new-head>
      <my-tabs :navList="navList" v-model="navIndex"></my-tabs>
      <div class="interviewTabs" v-if="navIndex == 1">
        <div
          v-for="(item, index) in interviewTabs"
          :key="index"
          class="flex-center"
          :class="{ active: interviewTabsIdx == index }"
          @click="interviewTabItenTap(index, item.check_status)"
        >
          {{ item.text }} <span v-if="item.num != null">({{ item.num }})</span>
        </div>
      </div>
    </div>
    <div :style="{ height: navIndex == 1 ? '3.5rem' : '2.4rem' }"></div>
    <index0 @setTabNum="setTabNum($event)" v-if="navIndex == 0"></index0>
    <index2 @setTabNum="setTabNum($event)" v-if="navIndex == 2"></index2>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="navIndex == 1">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getData"
      >
        <div class="resumeList">
          <div
            v-for="(item, i) in resumeList"
            :key="i"
            class="taskItem flex-center"
            @click="$router.push('/interviewInfo?task_id=' + item.task_id)"
          >
            <van-image
              class="taskImg"
              :src="require('../../assets/image/tags/jianlishaxuan.png')"
            />
            <div class="taskRight">
              <h5>{{ item.task_name }}</h5>
              <div class="line2 flex-center">
                <div v-if="item.task_tag == '高管'">{{ item.task_tag }}</div>
                <p>应聘者: {{ item.applicant_name }}</p>
              </div>

              <p class="flex-center">
                <span>{{ item.start_time }}-{{ item.end_time }}</span>
                <span>发布人: {{ item.crate_name }}</span>
              </p>
              <div class="taskBottom flex-center">
                <div class="prise">
                  <img src="@/assets/image/prise.png" alt="" />
                  <span>{{ moneyFormat(item.task_bonus) }}</span>
                </div>

                <div class="fillIn flex-center">
                  <!-- 发布简历阶段 -->
                  <template v-if="interviewTabsIdx == 1">
                    <span
                      v-if="item.is_permission == 1"
                      @click.stop="
                        $router.push('/InitiateInterview?task_id=' + item.task_id)
                      "
                      >发起面试</span
                    >
                  </template>
                  <!-- 填写面试评价阶段 -->
                  <template v-if="interviewTabsIdx == 0">
                    <span
                      v-if="item.is_permission == 1 && item.is_write == 0"
                      @click.stop="
                        $router.push('/addAssessment?type=2&task_id=' + item.task_id)
                      "
                      >填写面试评估表</span
                    >
                     <span
                      v-if="item.is_permission == 1 && item.is_write == 1"
                      @click.stop=""
                      class="disable"
                      >已填写</span
                    >
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <div class="add" @click="addResume" v-if="is_permission == '1'">
      <van-icon name="plus" color="#0286ff" />
    </div>
  </div>
</template>

<script>
import { resumeListApi, isPermissionApi } from "@/api/api/resume";
import index0 from "./components/index0.vue";
import index2 from "./components/index2.vue";
export default {
  components: {
    index2,
    index0,
  },
  data() {
    return {
      navList: [
        {
          text: "简历筛选",
          num: null,
        },
        {
          text: "面试评估",
          num: null,
        },
        {
          text: "评估结果",
          num: null,
        },
      ],
      navIndex: 0,
      interviewTabs: [
        {
          text: "待完成",
          num: null,
          check_status: "1",
        },
        {
          text: "待发布",
          num: null,
          check_status: "2",
        },
      ],
      interviewTabsIdx: 0,
      resumeList: [],
      total: null,
      params: {
        status: "2",
        check_status: "1",
        page: 0,
        size: 10,
      },
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      is_permission: null, //是否有发布简历权限
    };
  },
  watch: {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      let res = await isPermissionApi();
      console.log(res);
      this.is_permission = res.data.data.is_permission;
    },
    async getData() {
      this.loading = true;
      if (this.total == this.resumeList.length) {
        this.finished = true;
        // console.log('nomore')
        return;
      }
      this.params.page++;
      let res = await resumeListApi(this.params);
      let resData = res.data.data;
      this.setTabNum(resData.count_data);
      this.resumeList = [...this.resumeList, ...resData.data];
      this.total = resData.total;
      // console.log(resData.data);
      this.refreshing = false; //关闭下拉刷新组件状态
      this.loading = false; //关闭列表组件加载状态
    },
    onRefresh() {
      console.log("下拉刷新");
      this.params.page = 0;
      this.resumeList = [];
      this.finished = false;
      this.getData();
    },

    interviewTabItenTap(i, check_status) {
      if (this.interviewTabsIdx == i) {
        return;
      }
      this.interviewTabsIdx = i;
      this.params.check_status = check_status;
      this.params.page = 0;
      this.resumeList = [];
      this.total = null;
      this.finished = false;
      this.getData();
    },
    addResume() {
      this.$router.push("/addResume");
    },
    setTabNum(e) {
      this.navList[0].num = e.screen_num;
      this.navList[1].num = e.interview_num;
      this.navList[2].num = e.complete_num;
      this.interviewTabs[0].num = e.countTwo_pubic;
      this.interviewTabs[1].num = e.countTwo_ispubic;
    },
  },
};
</script>

<style lang="scss">
.interview {
  padding-bottom: 80px;

  .interviewTabs {
    display: flex;
    padding: 0 15px;
    font-size: 13px;
    background-color: #fff;

    > div {
      flex: 1;
      height: 40px;
      border-bottom: 1px solid #ccc;
    }

    .active {
      color: #0286ff;
    }
  }

  .resumeList {
    padding-top: 20px;
  }

  .taskItem {
    height: 100px;
    margin-top: 36px;
    padding: 0 15px;

    .taskImg {
      width: 100px;
      height: 100px;
    }

    .taskRight {
      flex: 1;
      margin-left: 13px;
      height: 100%;
      border-bottom: 1px solid #d8d8d8;

      h5 {
        display: flex;
        align-items: center;
        font-size: 14px;

        span {
          width: 50px;
          height: 16px;
          background: #0800f9;
          border-radius: 11px;
          color: #fff;
          font-size: 10px;
        }
      }

      .line2 {
        justify-content: flex-start;
        font-size: 13px;
        margin-top: 10px;

        > div {
          background-color: #ff7a15;
          color: #fff;
          padding: 2px 5px;
          border-radius: 4px;
          margin-right: 10px;
        }

        > p {
        }
      }

      > p {
        justify-content: space-between;
        font-size: 11px;
        color: #979797;
        margin-top: 8px;
        height: 15px;
        line-height: 15px;
      }

      .taskBottom {
        justify-content: space-between;
        margin-top: 8px;

        .prise {
          display: flex;
          align-items: center;

          img {
            width: 15px;
            height: 15px;
            margin-right: 5px;
          }
        }

        .fillIn {
          font-size: 12px;

          span {
            display: block;
            height: 20px;
            padding: 0 8px;
            border-radius: 10px;
            color: #fff;
            background-color: #ff7a15;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .disable {
            background-color: #ccc;
          }
        }
      }
    }

    &:first-child {
      margin-top: 0;
    }
  }

  .add {
    position: fixed;
    bottom: 100px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #0286ff;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 20px;
    }
  }
}
</style>
